<template>
    <div>
        <div id="Altizure" ref="serverDetail">
            <!--图标-->
            <ul class="icons">
                <li>
                    <span>航线规划</span>
                    <div @click="editor" style="cursor:pointer" class="radiu">
                        <img  class="iconImg" src="../../../static/Altizure/icon.png" alt="">
                    </div>
                </li>
                <li>
                    <span>开始任务</span>
                    <div style="cursor:pointer" class="radiu">
                        <img v-if="defaultPic" class="iconImg" src="../../../static/Altizure/fly01.png" alt="" @click="clickDefault">
                        <img v-if="changePic" class="iconImg" src="../../../static/Altizure/fly02.png" alt="" @click="clickCamera">
                    </div>
                </li>
            </ul>
            <!--编辑-->
            <div class="editorBox" v-if="editorBox">
                <div class="editorTitle">
                    <span style="cursor:pointer">编辑</span>
                    <span style="float: right;margin-right: 20px; cursor:pointer" @click="saveMeaaage()">保存</span>
                </div>
                <div class="editorContent">
                    <div class="hight ft">
                        <h3>高度</h3>
                        <div class="slider" id="one">
                            <span class="demonstration">{{height}}m</span>
                            <div class="hightSlider">
                                <el-slider v-model="height" :max="200" @change="clickId($event ,'one')"></el-slider>
                                <!--<el-slider v-model="height" @change="linePics1" :max="200"></el-slider>-->
                            </div>
                        </div>
                    </div>
                    <div class="over ft">
                        <h3>飞行方向</h3>
                        <div class="slider" id="two">
                            <span class="demonstration">{{hightSets.inclination}}°</span>
                            <div class="hightSlider">
                                <el-slider id="asdqwe" @change="clickId($event ,'two')" v-model="hightSets.inclination" :max="90"></el-slider>
                            </div>
                        </div>
                    </div>
                    <div class="over ft">
                        <h3>航向重叠率</h3>
                        <div class="slider">
                            <span class="demonstration">{{hightSets.course}}%</span>
                            <div class="hightSlider">
                                <el-slider v-model="hightSets.course"></el-slider>
                            </div>
                        </div>
                    </div>
                    <div class="over ft">
                        <h3>旁向重叠率</h3>
                        <div class="slider" id="three">
                            <span class="demonstration">{{hightSets.ateral}}%</span>
                            <div class="hightSlider">
                                <el-slider @change="clickId($event ,'three')" v-model="hightSets.ateral"></el-slider>
                                <!--<el-slider @change="linePics" v-model="hightSets.ateral"></el-slider>-->
                            </div>
                        </div>
                    </div>
                    <div class="over ft">
                        <h3>最大速度</h3>
                        <div class="slider">
                            <span class="demonstration">{{hightSets.maxSpeed}}m/s</span>
                            <div class="hightSlider">
                                <el-slider  v-model="hightSets.maxSpeed" @change="minSu" :max="15" :min="2"></el-slider>
                            </div>
                            <div>
                                <span v-model="hightSets.defaultSu">实际速度：{{hightSets.defaultSu}}m/s</span>
                            </div>
                        </div>
                    </div>
                    <div class="over ft">
                        <h3>最短拍照间隔</h3>
                        <div class="slider">
                            <span class="demonstration">{{hightSets.minTime}}s</span>
                            <div class="hightSlider">
                                <el-slider v-model="hightSets.minTime" @change="minSu"></el-slider>
                            </div>
                            <div>
                                <span v-model="hightSets.defaultGe">实际拍照间隔：{{hightSets.defaultGe}}s</span>
                            </div>
                        </div>
                    </div>
                    <div class="camera ft">
                        <h2>相机</h2>
                        <div class="cam">多光谱传感器Sequoia</div>
                    </div>
                    <div>
                        <h2>高级</h2>
                        <!--信息丢失后-->
                        <div class="lost">
                            <div class="leftLost">
                                <span>信号丢失后</span>
                            </div>
                            <div class="rightLost" @click="lostBox" style="cursor:pointer">
                                <span style="margin-right: 45px;color: rgb(169,169,169)">终止执行</span>
                                <div class="goImg">
                                    <img src="../../../static/Altizure/go.png" alt="">
                                </div>
                            </div>
                        </div>
                        <!--更多设置-->
                        <div class="more" @click="clickMore">
                            <div class="leftLost" style="cursor:pointer">
                                <span>详细参数信息</span>
                            </div>
                            <div class="goImg">
                                <img src="../../../static/Altizure/go.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--信号丢失后-->
            <div class="backBox" v-if="backBox">
                <div class="backBoxTitle">
                    <div class="backIcon" @click="clickBackBox">
                        <img src="../../../static/Altizure/back.png" alt="" style="vertical-align: middle">
                    </div>
                    <h2>信号丢失后</h2>
                </div>
                <div class="backBoxContent">
                    <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
                        <el-tab-pane label="终止任务（推荐）" name="first">
                            <div class="les">
                                失去遥控信号数秒后，飞机将自动取消任务，并触发失控行为。
                            </div>
                            <div class="les">
                                失控行为默认为返航，你可以在DJI Go中检查这个设置。如果它被设置为其他选项，我们也会在起飞前警告并提示你将它改为自动返航。
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="继续执行（危险）" name="second">
                            <div style="overflow-y: scroll;max-height: 195px;color: red">
                                <div class="les">
                                    注意：这是危险设置。无信号时，飞机可能无法在低电量时自动返航。因为低电量返航指令是在信号稳定时，由app发送的，所以只在信号稳定时才有效。
                                </div>
                                <div class="les">
                                    当以下情况同事发生时，飞机可能会立即自动原地降落导致丢机：
                                </div>
                                <div class="les">
                                    1.你启用了这个选项；<br/>
                                    2.信号丢失较长时间；<br/>
                                    3.任务完成前，电量低于严重低电量警告值（DJI Go中查看)
                                </div>
                                <div class="les">
                                    如果你确实需要开启这个选项，请确保电量用完前能重新获取连接或完成任务。
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
            <!--更多设置-->
            <div class="moreSet" v-if="moreSet">
                <div class="backBoxTitle">
                    <div class="backIcon" @click="clickBackBox">
                        <img src="../../../static/Altizure/back.png" alt="">
                    </div>
                    <h2>高级设置</h2>
                </div>
                <div class="moreSetContent">
                    <!--地面分辨率-->
                    <div class="over ft">
                        <h3>地面分辨率</h3>
                        <ul class="picWH">
                            <li>
                                <div>
                                    <span>焦距（毫米）:  4.88</span>
                                </div>
                            </li>
                            <li>
                                <span v-model="hightSets.picWidth">照片宽度（像素）：{{hightSets.picWidth}}</span>
                            </li>
                            <li>
                                <span v-model="hightSets.picHeight">照片高度（像素）：{{hightSets.picHeight}}</span>
                            </li>
                            <li>
                                <span v-model="hightSets.sensorWidth">传感器宽度（毫米）：{{hightSets.sensorWidth}}</span>
                            </li>
                            <li>
                                <span v-model="hightSets.sensorHeight">传感器高度（像素）：{{hightSets.sensorHeight}}</span>
                            </li>
                            <li>
                                <span>计算值</span>
                            </li>
                            <li>
                                <span v-model="hightSets.resolution" class="minPx">厘米/像素：{{hightSets.resolution}}</span>
                            </li>
                            <li>
                                <span v-model="hightSets.level">水平视场（米）：{{hightSets.photograph1}}</span>
                            </li>
                            <li>
                                <span v-model="hightSets.vertical">垂直视场（米）：{{hightSets.photograph2}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="over ft">
                        <h3>拍照数量</h3>
                        <div style="margin-top: 20px">
                            <span id="distance" v-model="hightSets.distance">距离（米）：{{hightSets.distance}} </span>
                        </div>
                        <div style="margin-top: 20px">
                            <span v-model="hightSets.quantity">拍照数量约（张）：{{hightSets.quantity}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!--相机-->
            <div class="cameras" v-if="cameraBox">
                <h2 style="border-bottom: 1px solid rgb(217,217,217);">起飞</h2>
                <!--安全状态检查-->
                <div style="padding: 15px">
                    <h3>安全状态检查</h3>
                    <div>
                        <el-checkbox label="GPS卫星数量超过13颗" name="type" style="margin-left: 30px;margin-top: 10px" v-model="checked1"></el-checkbox>
                        <el-checkbox label="螺旋桨已紧固，方向安装无误" name="type" style="margin-top: 10px" v-model="checked2"></el-checkbox>
                        <el-checkbox label="电池电量大于85%" name="type" style="margin-top: 10px" v-model="checked3"></el-checkbox>
                        <el-checkbox label="相机已开机，并摘下镜头盖" name="type" style="margin-top: 10px" v-model="checked4"></el-checkbox>
                        <el-checkbox label="云台转动正常，相机镜头垂直向下" name="type" style="margin-top: 10px" v-model="checked5"></el-checkbox>
                        <el-checkbox label="该区域为可飞行区域" name="type" style="margin-top: 10px" v-model="checked6"></el-checkbox>
                    </div>
                </div>
                <ul class="goWayContent">
                    <li @click="autoGoWay" style="cursor:pointer">
                        <span v-model="texts" v-text="texts"></span>
                        <div class="goImg">
                            <img src="../../../static/Altizure/go.png" alt="">
                        </div>
                    </li>
                    <!--<li @click="defaultLoader" style="cursor:pointer">-->
                        <!--<span>原地降落</span>-->
                        <!--<div class="goImg">-->
                            <!--<img src="../../../static/Altizure/go.png" alt="">-->
                        <!--</div>-->
                    <!--</li>-->
                    <li @click="defaultHig" style="cursor:pointer">
                        <span>返航高度</span>
                        <div class="zi">
                            <span style="margin-right: 20px;color: rgb(204,204,204)" v-model="noneMess">{{noneMess}}</span>
                            <div>
                                <img style="width: 20px" src="../../../static/Altizure/go.png" alt="">
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="goWayFoot">
                    <div @click="openFly">开始</div>
                    <div>停止</div>
                </div>
            </div>
            <!--自动返航-->
            <div class="goWay" v-if="auto">
                <div class="backBoxTitle" style="border-bottom: 1px solid rgb(217,217,217);">
                    <div class="backIcon" @click="clickGoWay" style="cursor:pointer">
                        <img src="../../../static/Altizure/back.png" alt="">
                    </div>
                    <h2>返航设置</h2>
                </div>
                <div class="goWayContent" style="border-bottom: 1px solid rgb(217,217,217);"  v-for="(goWayitems,index) in goWayStatus" :key="index" :class="{wayActive: WayIndex == index}" @click="changeFF(index,goWayitems.name)">
                    <span class="ff" v-model="contData">{{goWayitems.name}}</span>
                    <!--<span style="color: rgb(204,204,204);float: right">未知</span>-->
                </div>
                <!--<div class="goWayContent" style="border-bottom: 1px solid rgb(217,217,217);" @click="changeFF">-->
                    <!--<span class="ff">原地降落</span>-->
                    <!--&lt;!&ndash;<span style="color: rgb(204,204,204);float: right">未知</span>&ndash;&gt;-->
                <!--</div>-->
                <!--<div class="goWayContent" style="border-bottom: 1px solid rgb(217,217,217);margin-bottom: 160px" @click="changeFF">-->
                    <!--<span class="ff">手动控制</span>-->
                    <!--&lt;!&ndash;<span style="color: rgb(204,204,204);float: right">未知</span>&ndash;&gt;-->
                <!--</div>-->
                <!--<div class="goWayFoot">-->
                    <!--<div>开始</div>-->
                    <!--<div>停止</div>-->
                <!--</div>-->
            </div>
            <!--原地降落-->
            <div class="goWay" v-if="defaultWay">
                <div class="backBoxTitle" style="border-bottom: 1px solid rgb(217,217,217);">
                    <div class="backIcon" @click="clickGoWay" style="cursor:pointer">
                        <img src="../../../static/Altizure/back.png" alt="">
                    </div>
                    <h2>原地降落</h2>
                </div>
                <div class="goWayContent" style="border-bottom: 1px solid rgb(217,217,217);margin-bottom: 160px">
                    <span>状态</span>
                    <span style="color: rgb(204,204,204);float: right">未知</span>
                </div>
                <div class="goWayFoot">
                    <div style="cursor:pointer">开始</div>
                    <div style="cursor:pointer">停止</div>
                </div>
            </div>
            <!--返航高度-->
            <div class="goWay" v-if="backHight">
                <div class="backBoxTitle" style="border-bottom: 1px solid rgb(217,217,217);">
                    <div class="backIcon" @click="clickGoWay" style="cursor:pointer">
                        <img src="../../../static/Altizure/back.png" alt="">
                    </div>
                    <h2>返航高度</h2>
                </div>
                <div class="goWayContent" style="margin-bottom: 70px !important;margin-bottom: 160px">
                    <div>
                        <span>当前设置</span>
                        <span style="color: rgb(204,204,204);float: right" v-model="unKown">{{unKown}}</span>
                    </div>
                    <div style="margin-top: 40px">
                        <span>改为（20-500m)</span>
                        <div class="slider">
                            <span class="demonstration">{{value8}}m</span>
                            <div class="hightSlider">
                                <el-slider v-model="value8"></el-slider>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sure">
                    <span @click="sureMessage">确认修改</span>
                </div>
            </div>
            <!--飞行路线-->
            <div class="lineWay" v-if="linePic">
                <img style="opacity: .6" :src='images' alt="">
            </div>
            <!--feixing -->
            <div style="position: absolute;z-index:2000">
                <el-dialog :close-on-click-modal="false"  :modal-append-to-body="false" :close-on-press-escape="false" :visible.sync="ifShowIframe"   width="80%" top="10vh">
                    <ul class="tit">
                        <li class="list">飞行高度(m): <span v-model="height" v-text="height"></span></li>
                        <li class="list">飞行速度(m/s): <span  v-model="hightSets.defaultSu" v-text="hightSets.defaultSu"></span></li>
                        <li class="list">距离(m): <span v-model="hightSets.distance" v-text="hightSets.distance"></span></li>
                        <li class="list">飞行时间(分钟): <span v-model="hightSets.allTime" v-text="hightSets.allTime"></span></li>
                        <li class="list">卫星数量(颗): 19</li>
                        <li class="list">电池电量(%): 100</li>
                        <li class="list">飞行条带(条): <span v-model="hightSets.stripNum" v-text="hightSets.stripNum"></span></li>
                    </ul>
                    <div class="mdk-sheying" v-if=" src === paisheIf && ifPaisheLoaded">
                        <div style="display: inline-block;">
                            <img :src="'../../static/img/sheying/DSC_01'+ imgIndex + '[1472x982].jpg'"  height="200px" width="300px"  alt="">
                        </div
                        ><div style="display: inline-block;text-align:right;width:calc(100% - 300px);height:200px;vertical-align:top;">
                    </div>
                    </div>
                    <!--<iframe :src="src" class="mdk-main-iframe" frameborder="0" scrolling="no" seamless allowvr allowfullscreen mozallowfullscreen="true" webkitallowfullscreen="true" onmousewheel="">-->
                        <iframe id="mx"   class="mdk-main-iframe" frameborder="0">

                        </iframe>
                    <div style="width:100%;text-align: center !important;margin-top: 16px;">
                        <el-button type="primary" style="width: 128px !important;" @click="handleQifei(0)">起飞</el-button>
                        <el-button type="primary" style="width: 128px !important;" @click="handleQifei(1)">飞行任务</el-button>
                        <el-button type="primary" style="width: 128px !important;" @click="handleQifei(2)">降落</el-button>
                        <el-button type="primary" style="width: 128px !important;" @click="handleQifei(4)">返航</el-button>

                    </div>
                </el-dialog>
            </div>
            <!--坠毁-->
            <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="ifShowIframes" width="80%"
                       top="10vh">
                <div style="font-size: 18px" v-model="message" v-text="message"></div>

                <iframe :src="iframeSrc" class="mdk-main-iframe" frameborder="0" scrolling="no" seamless allowvr allowfullscreen
                        mozallowfullscreen="true" webkitallowfullscreen="true" onmousewheel=""></iframe>
            </el-dialog>
            <!--保存参数-->
            <div class="saveBox" v-if="box">
                <div class="saveTable">
                    <table>
                        <tr>
                            <td>面积(m²)：1000</td>
                            <td>照片数量：{{hightSets.quantity}}</td>
                            <td>飞行时间: {{hightSets.allTime}}分钟</td>
                        </tr>
                        <tr>
                            <td>距离(m):
                                <span v-model="hightSets.distance" v-text="hightSets.distance"></span>
                            </td>
                            <td>飞行条带: {{hightSets.stripNum}}</td>
                            <td>拍照间隔: {{hightSets.minTime}}</td>
                        </tr>
                        <tr>
                            <td>相片间距(m): {{hightSets.Photo}}</td>
                            <td>单幅照片面积(m²): {{hightSets.photograph1}}*{{hightSets.photograph2}}</td>
                            <td>空间分辨率: {{hightSets.resolution}}</td>
                        </tr>
                        <tr>
                            <td>航线间距(m): {{hightSets.track}}</td>
                            <td>飞行高度(m): {{height}}</td>
                            <td>飞行速度(m/s): {{hightSets.defaultSu}}</td>
                        </tr>
                    </table>
                </div>
                <div class="saveBoxBottom">
                    <el-button type="primary" style="margin-right: 15px" @click="saveBox">确定</el-button>
                    <el-button type="primary" @click="cancelBox">取消</el-button>
                </div>
            </div>
        </div>
        <div id="container"></div>
        <div id="mask"></div>
        <div>
            <newNav  :ifShowIframe="ifShowIframe"></newNav>
        </div>
    </div>
</template>
<script>
	import $ from './js/jquery-3.3.1.js'
	import xunfei from './js/xunfei.js'
	import snap from './js/snap.svg.js'
	import ModelViewer from '@/components/3D/ModelViewer.vue'
    import newNav from './newNav/index'
	export default {
		name:'tizure',
        components:{
            newNav,
        },
		data(){
			return {
                //f返航设置
                goWayStatus:[
                    {
                    	name:'自动返航'
                    },
	                {
		                name:'原地降落'
	                },
	                {
		                name:'手动控制'
	                },
                ],
                model:'',//模型
				WayIndex:-1,
				contData:'自动返航',
				texts:'自动返航',
                activeIndex:'',
				paisheIf:'',
				point : [],
				pointOverlay : [],
				defaultMessage:'未知',
				checked1:false,
				checked2:false,
				checked3:false,
				checked4:false,
				checked5:false,
				checked6:false,
				box:false,
				iframe:'',
				ifShowIframe: false,
				src: undefined,
                iframeSrc:'',
                model3D:'',//3D模型
				imgIndex: 43,
				ifPaisheLoaded: false,
				ifShowIframes:false,
				//点击次数
				clickNum:0,
				height: 0,
				value2: 0,
				activeName2: 'first',
				backBox:false,
				editorBox:false,
				//  高级设置
				moreSet:false,
				fly : null,
				hightSets:{
					course:85,
					ateral:85,
					inclination:90,
					maxSpeed:6,
					minTime:3,
					defaultSu:2.6,
					defaultGe:5,
					resolution:'',
					quantity:'',
					//地面分辨率
					picWidth: 4609,
					picHeight:3456,
					sensorWidth:6.2,
					sensorHeight:4.6,
					num8:5,
					//  旁向率与角度
					distance:'',
					//    飞行时间
					allTime:'',
					//    飞行条带
					stripNum:'',
					//    航线间距
					track:'',
					//    相片间距
					Photo:'',
					//    每条航带上的照片数
					trackPhoto:'',
					//    单幅照片面积
					photograph1:'',
					photograph2:''
				},
				//  相机
				value:false,
				cameraBox:false,
				linePic:false,
				//    起飞
				isFly:false,
				images:'../../../static/Altizure/1bn.png',
				defaultPic:true,
				changePic:false,
				noneMess:'未知',
				totalLength:'',
				//  自动返航
				auto:false,
				goWay:false,
				defaultWay:false,
				unKown:'???',
				value8: 0,
				backHight:false,
				imgStrOpen:'1bn',
				message:'由于[起飞地点]上方有遮挡，飞行任务失败。请到数据中心->飞行结果查询中删除任务重新飞行'
			}
		},
		mounted() {
			this.ready();
		},
		methods: {
            handleLoaded(){
                scene.moSpecial.cameraSettings({ left: 120, right:120, up: 80, down: 80, in: 0, out: 0});
            },
            randomFolder(){
                console.log(111)
                this.model='14HzK7e0le1n94165e52Hk3sxv1R2Oxk'
                return '14HzK7e0le1n94165e52Hk3sxv1R2Oxk'
            },
			//选择返航设置
			changeFF(index,name){
				this.WayIndex = index
                this.contData = name
                console.log(this.contData)
            },
			//获取所有模型
			getModel(){
				// 大疆1  ebee2
				// 山地1 良乡 2
				console.log(this.$route.query);
				let params ={
					type:'4,5,6,7,9',
					sceneRef: this.$route.query.feixingqi +  this.$route.query.indexArr
				}
				this.$axios.get(this.URL.uModel.selectUModelList,{params})
					.then(res=>{
						if (res.status === 200){
							console.log(res);
							this.getData =res.data
						}
					})
					.catch(err=>{
					})
			},
			handleMessage(){
				//接受来自模型iframe的消息，判断是否加载完成
				window.addEventListener('message', (e) => {
					if(!e.data.type){
						return
					}
					switch (e.data.type) {
						case 'Loaded':
							if(this.iframeSrc === this.paisheIf ){
								this.ifPaisheLoaded = true
							}
							break;
						case 'LabelList':

							break;
						default:
							return
					}
				}, false)
			},
			handle() {
                this.ifShowIframe = true;
                for (let i in this.getData){
                    if ( this.getData[i].type === 4){
                        this.$nextTick(()=>{
                            document.getElementById('mx').src= this.$newUrl + '#/webglTest?model3D=' + this.getData[i].dir_name
                        })

                    }
                }
                this.activeIndex = 0

			},
			handleQifei(index) {
				if (index === 0) {
					//起飞
					this.ifShowIframe = true
					for (let i in this.getData){
						if ( this.getData[i].type === 4){
                            document.getElementById('mx').src= this.$newUrl + '#/webglTest?model3D=' + this.getData[i].dir_name
						}
					}
					this.activeIndex = 0
				} else if (index === 2) {
					//降落
					this.ifShowIframe = true
					this.optionIds='23,24'
					this.select()
					for (let i in this.getData){
						if ( this.getData[i].type === 6){
                            // this.iframeSrc = this.$newUrl + '#/webglTest?model3D=' + this.getData[i].dir_name
                            document.getElementById('mx').src= this.$newUrl + '#/webglTest?model3D=' + this.getData[i].dir_name
							console.log(this.iframeSrc + '降落')
                        }
					}
				} else if (index === 1) {
					this.ifShowIframe = true
					//飞行任务
					this.optionIds='21,22'
					this.select()
					for (let i in this.getData){
						if ( this.getData[i].type === 5){
							// this.paisheIf = this.getData[i].img_url
                            // this.iframeSrc = this.$newUrl + '#/webglTest?model3D='+ this.getData[i].dir_name
                            document.getElementById('mx').src= this.$newUrl + '#/webglTest?model3D=' + this.getData[i].dir_name
							console.log(this.iframeSrc + '飞行任务')
						}
					}
					setInterval(() => {
						if (this.imgIndex === 72) {
							this.imgIndex = 43
						}
						this.imgIndex++
					}, 1000)
				} else {
                    this.ifShowIframe = true;

                    for (let i in this.getData){
                        console.log(this.getData[i].type);
                        if ( this.getData[i].type === 9){
                            console.log(this.$newUrl + '#/webglTest?model3D=' + this.getData[i].dir_name);
                            document.getElementById('mx').src= this.$newUrl + '#/webglTest?model3D=' + this.getData[i].dir_name
	                        console.log(this.iframeSrc + '返航')
                        }
                    }


				}
                console.log("点击hou"+this.iframeSrc)
                document.getElementById('mx').contentWindow.location.reload(true);
			},
			//外包id
			getAssessmentId() {
				this.$axios.post(this.URL.uUserTask.assessment).then(res => {
					if (res.status === 200) {
						sessionStorage.setItem('AltizureId', res.data.userTaskId)
					}
				})
			},
			select(){
				if(sessionStorage.flag){
					return false
				}else{
					let data ={
						optionIds: this.optionIds,
						taskId: sessionStorage.AltizureId
					}
					this.$axios.post(this.URL.uUserTask.select, data).then(res => {
						if (res.status === 200){
							this.optionIds= []
							console.log(res);
						}
					}).catch(err => {

					})
				}

			},
			formatTooltip(val) {
				return val / 100;
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			clickBackBox(){
				this.editorBox = true
				this.backBox = false
				this.moreSet = false
			},
			lostBox(){
				this.backBox = true
				this.editorBox = false
			},
			clickMore(){
				if(this.height <= 0 || this.hightSets.defaultSu <= 0 || this.hightSets.defaultGe <= 0 ){
					this.$alert('请设置正确有效的参数（范围不可<=0)', '提示', {
						confirmButtonText: '确定',
						callback: action => {
							this.hightSets.quantity = ''
						}
					});
				}else{
					this.moreSet = true
					this.editorBox = false
					this.clickNum = this.clickNum +1
					this.hightSets.inclination = this.hightSets.inclination
					this.hightSets.defaultSu = this.hightSets.maxSpeed
					this.hightSets.defaultGe = this.hightSets.minTime
					//赋值距离
					this.hightSets.distance = Math.ceil(this.$page.totalLength)


					//  拍照数量=距离/速度/时间
					let numPho = this.hightSets.distance/this.hightSets.defaultSu/this.hightSets.defaultGe
					this.hightSets.quantity=(numPho+"").split('.')[0]
					//  地面分辨率=cmos尺寸*高度/高度像素/焦距
					let numReso = this.hightSets.sensorHeight/this.hightSets.picHeight*this.height/this.hightSets.num8*100
					this.hightSets.resolution = numReso.toFixed(3)
					//    飞行时间
					let allTime= this.hightSets.distance/this.hightSets.defaultSu
					let timeAll = Math.ceil(allTime)
					let h
					let s
					h = Math.floor(timeAll/60)
					s  =   timeAll/60
					h    +=    '';
					s    +=    '';
					h  =   (h.length === 1)?'0'+h:h;
					s  =   (s.length === 1)?'0'+s:s.split('.')[0]
					this.hightSets.allTime = h+':'+s;
					//单幅照片面积宽=宽度像素*地面分辨率/100
					let photograph1 = this.hightSets.picWidth*this.hightSets.resolution/100
					this.hightSets.photograph1 = Math.ceil(photograph1)
					//单幅照片面积高=高度像素*地面分辨率/100
					let photograph2 = this.hightSets.picHeight*this.hightSets.resolution/100
					this.hightSets.photograph2 = Math.ceil(photograph2)
				}
			},
			//最大速度和最短拍照间隔
			minSu(){
				if(this.hightSets.maxSpeed <= 0 || this.hightSets.minTime <= 0){
					this.$alert('请设置正确有效的参数（范围不可<=0)', '提示', {
						confirmButtonText: '确定',
						callback: action => {
							this.hightSets.maxSpeed = 6
							this.hightSets.minTime = 3
						}
					});
				}
			},
			editor(){
				this.linePic = true
				this.editorBox = !this.editorBox
				this.goWay = false
				this.cameraBox = false
				this.backBox = false
				this.moreSet = false
				this.auto = false
				this.defaultWay = false
				this.backHight = false
				this.box = false
			},
			clickGoWay(){
				this.texts = this.contData
				this.auto = false
				this.defaultWay = false
				this.goWay = true
				this.backHight = false
				this.cameraBox = true
				this.unKown = this.value8
				this.noneMess = this.value8
			},
			autoGoWay(){
				this.auto = true
				this.goWay = false
				this.cameraBox = false
			},
			clickCamera(){
				this.cameraBox = !this.cameraBox
				this.editorBox = false
				this.goWay = false
				this.backBox = false
				this.moreSet = false
				this.auto = false
				this.defaultWay = false
				this.backHight = false
				this.linePic = true
				this.box = false
			},
			clickDefault(){
				this.editorBox = false
				this.backBox = false
				this.moreSet = false
				this.cameras = false
				this.goWay = false
				this.box = false
				this.$alert('请保存/返回编辑页面设置参数再执行此操作', '提示', {
					confirmButtonText: '确定',
					callback: action => {
						this.editorBox = true
						this.box = false
					}
				});
			},
			ready: function () {
				// var map = new BMap.Map('container')
                var map = new BMap.Map("container", { mapType: BMAP_SATELLITE_MAP });
                this.fly = new Fly('svg' , map , $);
                var polygon;
                if (this.$route.query.indexArr == 'b'){//加载学校模拟地图
                    var centerPoint = new BMap.Point(116.605749,39.79863)//学校
                    map.addControl(new BMap.MapTypeControl());
                    // map.disableDragging();
                    map.setMinZoom(16);
                    map.setMaxZoom(18);
                    map.enableScrollWheelZoom();   //启用滚轮放大缩小，默认禁用
                    //map.disableDoubleClickZoom();//禁用双击放大
                    map.centerAndZoom(centerPoint, 17)
                    polygon = new BMap.Polygon([
                        new BMap.Point(116.605749,39.80063),
                        new BMap.Point(116.615749,39.80063),
                        new BMap.Point(116.615749,39.79563),
                        new BMap.Point(116.605749,39.79563),
                    ], {strokeColor:"blue", strokeWeight:2, strokeOpacity:0.5});  //创建多边形
                }else {//加载山地模拟地图
                    var centerPoint = new BMap.Point( 116.147241,40.006045)//山地
                    map.addControl(new BMap.MapTypeControl());
                    map.setMinZoom(16);
                    map.setMaxZoom(18);
                    map.enableScrollWheelZoom();   //启用滚轮放大缩小，默认禁用
                    //map.disableDoubleClickZoom();//禁用双击放大
                    map.centerAndZoom(centerPoint, 17)
                    polygon = new BMap.Polygon([
                        new BMap.Point(116.147241,40.011045),
                        new BMap.Point(116.157241,40.011045),
                        new BMap.Point(116.157241,40.006045),
                        new BMap.Point(116.147241,40.006045),
                    ], {strokeColor:"blue", strokeWeight:2, strokeOpacity:0.5});  //创建多边形
                }

                map.addOverlay(polygon);   //增加多边形
				polygon.id = "outLine";
				polygon.enableEditing();
				var thit = this;
				var drawLine = function () {
					var arr = [];
					arr = polygon.getPath();
					var adjustArr = [];
					for (var i = 0; i < arr.length; i++) {
						adjustArr.push({
							lng: arr[i].lng,
							lat: arr[i].lat
						});
					}
					thit.fly.pointArr = adjustArr;//矩形点坐标
					thit.fly.rotate=90;  //旋转角度
					thit.fly.space=50;    //飞行间隔
					thit.fly.reset();
					$('.mianji span').html(thit.fly.getArea(polygon).toFixed(2));//航线面积
				}
				polygon.addEventListener("lineupdate", drawLine);
				//polygon.disableEditing();
			},
			//clickId id按下的事件
			clickId(event , index){
				let checkId = document.getElementById(index)
				let evt =  event | window.event
				console.log(this.totalLength)
				console.log(evt)
				if (index === "one") {
					this.fly.reset();
				}
				if (index === "three") {
					// var space = Math.ceil(evt * 100)
					if (evt > 70) {
						this.fly.changeSpace(evt * (-0.3) + 31);
					}
					else {
						this.fly.changeSpace(100 - evt - 20);
					}
					this.fly.reset()
				}
				if (index === "two") {
					this.fly.changeRotate(evt);
					this.fly.reset();
				}
				this.hightSets.distance = this.totalLength
				console.log(this.totalLength)
			},
			handleChange(value) {
				console.log(value);
			},
			defaultLoader(){
				this.defaultWay = true
				this.goWay = false
				this.cameraBox = false
			},
			sureMessage(){
				this.unKown = this.value8
			},
			defaultHig(){
				this.backHight = true
				this.goWay = false
				this.cameraBox = false
			},
			saveMeaaage(){
				if(this.height <= 0 || this.hightSets.defaultSu <= 0 || this.hightSets.defaultGe <= 0 ){
					this.$alert('请设置正确有效的参数（范围不可<=0)', '提示', {
						confirmButtonText: '确定',
						callback: action => {
							this.hightSets.quantity = ''
						}
					});
				}else if(this.height < 40){
					this.$alert('您设置的飞行高度过低，会发生危险！', '提示', {
						confirmButtonText: '确定',
					});
				}else if(this.height > 150){
					this.$alert('您设置的飞行高度过高，会发生危险！', '提示', {
						confirmButtonText: '确定',
					});
				}else{
					this.clickMore()
					this.box = true
					this.moreSet = false
					this.editorBox = false
					//    航带数
					let stripNum = 1000 / (this.hightSets.photograph2 * (1 - this.hightSets.ateral / 100))
					this.hightSets.stripNum = Math.ceil(stripNum)
					//    航线间距
					let track = 1000 / this.hightSets.stripNum
					this.hightSets.track = track.toFixed(1)
					//    每条航带上的照片数
					let trackPhoto = 1000 / (this.hightSets.photograph1 * (1 - this.hightSets.course / 100))
					this.hightSets.trackPhoto = Math.ceil(trackPhoto)
					//    相片间距
					let Photo = 1000 / this.hightSets.trackPhoto
					this.hightSets.Photo = Photo.toFixed(1)
				}
			},
			cancelBox(){
				this.box = false
				this.changePic = false
				this.defaultPic = true
			},
			saveBox(){
				if(this.hightSets.allTime > '25:00'){
					this.$alert('飞行时间过长，无人机容易坠毁，请重新规划航线', '提示', {
						confirmButtonText: '确定',
						callback: action => {
							this.box = false
							this.editorBox = true
						}
					})
				}else{
					this.box = false
					this.changePic = true
					this.defaultPic = false
				}
			},
			openFly(){
				if(this.checked1 === true && this.checked2 === true && this.checked3 === true && this.checked4 === true && this.checked5 === true && this.checked6 === true){
					let params = {
						height: this.height,
						course: this.hightSets.course,
						ateral: this.hightSets.ateral,
						inclination:this.hightSets.inclination,
						maxSpeed:this.hightSets.defaultSu,
						minTime:this.hightSets.defaultGe,
						//地面分辨率
						resolution:this.hightSets.resolution,
						//拍照数量
						quantity:this.hightSets.quantity,
						//    重置参数点击次数
						clickTimes:this.clickNum,
						// userTaskId:sessionStorage.getItem("taskId")
					}
					if(this.clickNum > 0){
						if (this.hightSets.course < 60){
							//航向重叠率<60    请设置正确的航向重叠率（》=60°）
							this.$alert('请设置正确的航向重叠率（范围 >= 60%）', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									this.cameraBox = false
									this.editorBox = true
								}
							});
						}else if(this.hightSets.ateral < 40){
							//航向重叠率<40    请设置正确的旁向重叠率（》=40°）
							this.$alert('请设置正确的旁向重叠率（范围 >= 40%）', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									this.cameraBox = false
									this.editorBox = true
								}
							});
						}else if(sessionStorage.flag){
							this.$confirm('按下“执行”按钮后，进入到无人机拍摄执行任务步骤!', '提示', {
								distinguishCancelAndClose: true,
								confirmButtonText: '执行',
								cancelButtonText: '取消'
							}).then(() => {
								this.$message({
									type: 'info',
									message: '操作成功',
								});
								this.cameraBox = false
								//判断起飞
								if(this.$route.query.qifei === '起飞地点A' || this.$route.query.tianqi ==='nTvQyAF3WjRhP76ybn5R8WCJ73320GPk'){
									if ( this.$route.query.tianqi ==='nTvQyAF3WjRhP76ybn5R8WCJ73320GPk'){
										this.message = "由于[大风天气]，飞行任务失败。请到数据中心->飞行结果查询中删除任务重新飞行";
									}
									this.ifShowIframes = true
									for (let i in this.getData){
										if(this.getData[i].type === 7){
                                            this.iframeSrc = this.$newUrl + '#/webglTest?model3D=' + this.getData[i].dir_name
                                            // document.getElementById('mx').src= this.$newUrl + '#/webglTest?model3D=' + this.getData[i].dir_name
										}
									}
								}else{
                                    console.log('执行');
                                    this.handle()
								}
							}).catch(action => {
								this.$message({
									type: 'info',
									message: action === 'cancel'
										? '已取消'
										: '已取消'
								})
							});
						}else{
							this.$axios.get(this.URL.uUserTask.randomResutl, {params}).then(res =>{
								if(res.status === 200){
									//打分接口
									let data = {
										optionIds:'12,13,14,15,16',
										taskId:sessionStorage.AltizureId
									}
									this.$axios.post(this.URL.uUserTask.select, data).then(res =>{
										if(res.status === 200){
											this.$confirm('按下“执行”按钮后，进入到无人机拍摄执行任务步骤!', '提示', {
												distinguishCancelAndClose: true,
												confirmButtonText: '执行',
												cancelButtonText: '取消'
											}).then(() => {
												this.$message({
													type: 'info',
													message: '操作成功',
												});
												this.cameraBox = false;
												//判断起飞
												if(this.$route.query.qifei === '起飞地点A' || this.$route.query.tianqi ==='nTvQyAF3WjRhP76ybn5R8WCJ73320GPk'){
													if ( this.$route.query.tianqi ==='nTvQyAF3WjRhP76ybn5R8WCJ73320GPk'){
														this.message = "由于[大风天气]，飞行任务失败。请到数据中心->飞行结果查询中删除任务重新飞行";
													}
													for (let i in this.getData){
														if(this.getData[i].type === 7){
                                                            this.iframeSrc = this.$newUrl + '#/webglTest?model3D=' + this.getData[i].dir_name
                                                            // document.getElementById('mx').src= this.$newUrl + '#/webglTest?model3D=' + this.getData[i].dir_name
														}
													}
													this.ifShowIframes = true
												}else{
                                                    console.log(2222);
                                                    this.handle()
												}
											}).catch(action => {
												this.$message({
													type: 'info',
													message: action === 'cancel'
														? '已取消'
														: '已取消'
												})
											});
										}
									})

								}
							})
						}

					}else{
						this.$alert('请回到编辑页设置参数!', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								this.cameraBox = false
								this.editorBox = true

							}
						});
					}
				}else{
					this.$alert('安全状态检查需全部选中状态才可开始起飞!', '提示', {
						confirmButtonText: '确定',
					});
				}

			},
		},
		created() {
            console.log(this.$route);
            //获取模型
			this.getModel()
			this.getAssessmentId()
			this.handleMessage()
		},
		watch:{
		}
	}
</script>

<style scoped>
    .tit{
        display: flex;
    }
    .list{
        margin-right: 2%;
    }
    .wayActive{
        color: rgb(64,158,255);
    }
    html,body{
        height:100%;
        overflow:hidden;
        position:relative;
        padding: 0;
        margin: 0;
    }
    #container{
        height: 100%;
        width: 100%;
        position: absolute;
        top:0;
        left: 0;
        z-index: 100;
    }
    #mask{
        display: none;
        height: 100%;
        width: 100%;
        position: absolute;
        top:0;
        left: 0;
        z-index: 101;
    }
    .BMap_contextMenu >div{
        height: 30px;
        line-height: 30px!important;
        font-size: 15px!important;
    }
    .saveBox{
        width: 600px;
        height: 310px;
        background: #fff;
        border-radius: 4px;
        position: absolute;
        z-index: 111;
        top: 50%;
        left: 50%;
        margin: -155px 0 0 -300px;
    }
    .saveTable{
        width: 96%;
        height: 75%;
        font-size: 16px;
        border: 1px solid rgb(242,242,242);
        text-align: center;
        margin: 15px auto;
    }
    .saveTable table{
        width: 100%;
    }
    .saveTable table tr{
        border-bottom: 1px solid rgb(242,242,242);
    }
    .saveTable table tr:last-child{
        border-bottom:none;
    }
    .saveTable table tr td{
        line-height: 57px;
        border-right: 1px solid rgb(242,242,242);
    }
    .saveTable table tr td:nth-child(3){
        border-right:none
    }
    .saveBoxBottom{
        text-align: center;
    }

    .header-title {
        position: absolute;
        font-size: 18px;
        font-weight: 700;
        margin-left: 100px;
        z-index: 1
    }

    .bottomButton {
        width: 300px;
        position: absolute;
        left: 50%;
        bottom: 0;
        display: flex;
        margin-left: -150px;
        /*div {*/
        /*width: 250px;*/
        /*}*/
    }
    .iframe-content {
        left: 0;
        top: 0;
        position: fixed;
        right: 0;
        bottom: 0;
    div {
        width: 30px;
        height: 30px;
        position: absolute;
        right: 20px;
        top: 20px;
    }

    iframe {
        width: 100%;
        height: 100vh;
    }
    }
    .mdk-main-iframe {
        width: 100%;
        height: 65vh;
    }
    .mdk-sheying {
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: 200px;
        z-index: 2;
        margin-bottom: -200px;
    }
    .mdk-label {
        position: absolute;
        width: 128px !important;
        visibility: hidden;
    }
    .mdk-location {
        position: absolute;
        visibility: hidden;
        font-size: 32px;
        color: #F56C6C;
    }
    #Altizure{
        height: 100%;
        width: 100%;
        /*position: relative;*/
        display: table;
        min-width: 1400px;
    }
    .page img{
        width: 100%;
        height: 100%;
        position: fixed;
        min-width: 1400px;
    }
    .icons{
        position: absolute;
        z-index: 111;
    }
    .icons li{
        position: relative;
        top: calc(50vh - 280px);
        margin-left: 60px;
        margin-top: 30px;
        display: flex;
    }
    .icons li span{
        line-height: 40px;
        height: 40px;
        margin-right: 5px;
        font-size: 18px;
        background: #fff;
        border-radius: 5px;
        padding-left: 5px;
        padding-right: 5px;
        font-weight: bold;
    }
    .radiu{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #fff;
        opacity: .7;
    }
    .iconImg{
        width: 30px;
        height: 30px;
        top:50%;
        left: 50%;
        margin: 10px 0 0 10px;
    }
    .editorBox{
        width: 320px;
        height: 410px;
        position: absolute;
        z-index: 111;
        top: 30vh;
        left: 18%;
        background: #fff;
        border-radius: 4px;
    }
    .editorTitle{
        text-align: center;
        margin-top: 8px;
    }
    .editorTitle span:first-child{
        font-size: 16px;
        background: rgb(64,158,255);
        padding: 10px 16px;
        color: #fff;
        border-radius: 4px;
    }
    .editorContent{
        padding: 0px 15px;
        overflow-y: scroll;
        max-height: 360px
    }
    .slider{
        margin-top: 5px;
    }
    .ft{
        margin-bottom: 20px;
    }
    .cam{
        margin-top: 6px;
        font-size: 16px;
    }
    /*信号丢失后*/
    .backBox{
        width: 320px;
        height: 300px;
        position: absolute;
        z-index: 111;
        top: 30vh;
        left: 18%;
        background: #fff;
        border-radius: 4px;
    }
    .backBoxTitle{
        padding: 5px 10px;
        display: flex;
    }
    .backIcon{
        width: 25px
    }
    .backIcon img{
        width: 100%;
    }
    .backBoxTitle h2{
        margin: 0 auto;
    }
    .backBoxContent{
        margin-top: 10px;
    }
    .les{
        padding: 0 20px 10px;
    }
    .lost{
        display: flex;
        font-size: 16px;
        margin-top: 6px;
        position: relative;
        border-bottom: 1px solid rgb(217,217,217);
        padding-bottom: 10px;
    }
    .rightLost{
        display: flex;
        position: absolute;
        right: 0px;
    }
    .goImg{
        width: 20px;
        position: absolute;
        right: 20px;
    }
    .goImg img{
        width: 100%;
    }
    .more{
        display: flex;
        margin-top: 12px;
        font-size: 16px;
        position: relative;
    }
    /*高级设置*/
    .moreSet{
        width: 320px;
        height: 400px;
        position: absolute;
        z-index: 111;
        top: 30vh;
        left: 18%;
        background: #fff;
        border-radius: 4px;
    }
    .moreSetContent{
        margin-top: 10px;
        max-height: 347px;
        overflow-y: scroll;
        margin: 15px;
    }
    .backColor{
        background: rgb(33,150,243);
    }
    /*返航*/
    .goWay{
        width: 320px;
        height: 300px;
        position: absolute;
        z-index: 111;
        top: 30vh;
        left: 18%;
        background: #fff;
        border-radius: 4px;
    }
    .goWay h2{
        text-align: center;
        padding: 5px 0;
    }
    .goWayContent{
        padding: 15px;
        font-size: 16px;
        /*margin-bottom: 30px;*/
    }
    .goWayContent li{
        display: flex;
        height: 30px;
        line-height: 30px;
        border-bottom: 1px solid rgb(217,217,217);
        margin-bottom: 10px;
    }
    .goWayContent li div img{
        vertical-align: middle;
    }
    .zi{
        display: flex;
        right: 20px;
        position: absolute;
    }
    /*自动返航*/
    .goWayFoot{
        display: flex;
        width: 100%;
        border-top: 1px solid rgb(217,217,217);
        padding-top: 10px;
    }
    .goWayFoot div{
        width: 50%;
        text-align: center;
        color: rgb(33,150,243);
    }
    .goWayFoot div:first-child{
        border-right: 1px solid rgb(217,217,217);
        color: red !important;
    }
    .sure{
        font-size: 16px;
        color: rgb(33,150,243);
        text-align: center;
    }
    /*相机*/
    .cameras{
        width: 320px;
        height: 410px;
        position: absolute;
        z-index: 111;
        top: 30vh;
        left: 18%;
        background: #fff;
        border-radius: 4px;
        /* overflow-y: scroll; */
        padding-bottom: 10px;
    }
    .cameras h2{
        text-align: center;
        padding: 5px 0;
    }
    .lineWay{
        position: absolute;
        right: 200px;
        top: 300px;
    }
    .picWH li{
        margin-top: 20px;
    }
    .minPx{
        max-width: 108px;
        overflow: hidden;
        display: block;
        white-space: nowrap;
    }
    .picNum{
        max-width: 130px;
        overflow: hidden;
        display: block;
        white-space: nowrap;
    }
    .hightSlider{
        margin-top: -25px;
        width: 80% !important;
        margin-left: 45px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Altizure/Altizure.vue